import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl } from '../../common/rcs_gaz_mc_core_FE';
import { TennisMatchRowWrapper } from './styles';
import LocalStorageUtility from '../../common/localStorageUtility/localStorageUtility';
import PreferredStar from '../PreferredStar';
import TeamLabel from '../TeamLabel';
import Label from '../shared/Label';
import IconFont from '../shared/IconFont';
import ConfigManager from '../../common/configManager/configManager';
import TennisTiming from '../TimeResults/TennisTiming';
import TennisResult from '../TimeResults/TennisResult';
import * as status from '../../constants/';

const playerNameLabel = (playerObj, isMobile) => {
  if (isMobile) {
    const firstNameCharacter = playerObj.get('firstName').charAt(0);
    return `${firstNameCharacter}. ${playerObj.get('lastName')}`;
  }
  return playerObj.get('displayName');
};

const isLive = match => (match.get('status') === status.INPLAY);

const TennisMatchRow = ({
  matchRow, isMobile, showRowScorer,
  sportId, actions, date,
}) => {
  const countriesUrl = ConfigManager.getCountriesFlag();
  const handleFavourites = () => {
    if (!showRowScorer) {
      if (!LocalStorageUtility.isPreferred(matchRow.get('matchId'))) {
        actions.showTooltip();
        setTimeout(() => {
          actions.hideTooltip();
        }, 2500);
      }
      actions.favouriteGame(sportId, matchRow.get('matchId'));
      actions.setFavouritesOnCompetition(matchRow.get('matchId'));
    } else {
      actions.removefavouriteGame(sportId, matchRow.get('matchId'), date);
    }
  };

  const isHomeWinner = (home, away) => {
    let homeWinner;
    if (matchRow.get('statusDetail') === status.WIN) {
      homeWinner = home > away;
    } else if (matchRow.get('matchDetails') && (matchRow.getIn(['firstEntry', 'id']) === matchRow.getIn(['matchDetails', 'winId']))) {
      homeWinner = true;
    }
    return homeWinner;
  };

  const isAwayWinner = (home, away) => {
    let awayWinner;
    if (matchRow.get('statusDetail') === status.WIN) {
      awayWinner = away > home;
    } else if (matchRow.get('matchDetails') && (matchRow.getIn(['secondEntry', 'id']) === matchRow.getIn(['matchDetails', 'winId']))) {
      awayWinner = true;
    }
    return awayWinner;
  };

  let playerIncrement = 0;

  const twoPlayerFounded = (immutableObject, increment, mobile, top) => {
    let separator = '';
    if (immutableObject > 1 && increment < 2) {
      separator = <span style={{ margin: mobile ? top ? '0px -4px 0px 6px' : '7px -4px 0px 6px' : '0px 5px' }}> / </span>;
    }
    return separator;
  };

  const resetIncrement = () => {
    playerIncrement > 1 ? playerIncrement = 0 : '';
  };

  const parseTennisPlayerNames = (playerObj) => {
    const players = playerObj.getIn(['players']);
    if (!players) return '';
    if (players.size > 1) {
      return `${players.getIn([0, 'lastName']) ? players.getIn([0, 'lastName']) : ''}-${players.getIn([1, 'lastName']) ? players.getIn([1, 'lastName']) : ''}`
    }
    return players.getIn([0, 'lastName']) ? players.getIn([0, 'lastName']) : '';
  }

  return (
    <TennisMatchRowWrapper
      href={prettyMatchUrl(
        parseTennisPlayerNames(matchRow.getIn(['firstEntry'])),
        parseTennisPlayerNames(matchRow.getIn(['secondEntry'])),
        matchRow.get('matchId'), 8, '', process.env.REACT_APP_SITE,
        `${matchRow.getIn(['tournament', 'name']).replace(' - ', '-')}-${matchRow.getIn(['competition', 'competitionId'])}`,
      )}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          onClick={event => event.preventDefault()}
          md={1}
          sm={1}
          xs={1}
          style={{
            top: isMobile ? '3px' : '7px',
            paddingLeft: isMobile ? '10px' : '15px',
            paddingRight: isMobile ? '0px' : '10px',
            alignSelf: 'flex-start',
            marginTop: '8px',
          }}
        >
          <PreferredStar handleFavourites={handleFavourites} isSelected={matchRow.get('favourite')} />
        </Col>
        <Col
          lg={6.35}
          md={5.7}
          sm={5.7}
          xs={5.7}
          style={{
            paddingLeft: '0px',
            paddingRight: isMobile ? '5px' : '10px',
            marginTop: '0.6em',
            marginBottom: '0.6em',
          }}
        >
          <Row style={{
            width: '100%', marginRight: '0', marginLeft: '0', marginBottom: '0px', alignItems: 'center',
          }}
          >
            {!isMobile && matchRow.getIn(['firstEntry', 'players']) && matchRow.getIn(['firstEntry', 'players']).size < 2 &&
              <Col
                lg={1.45}
                md={1.45}
                sm={1.45}
                xs={1.45}
                style={{
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
              >
                <TeamLabel
                  image={`${countriesUrl}${matchRow.getIn(['firstEntry', 'players', 0, 'nationality'])}.jpg`}
                  isFlag
                />
              </Col>
            }
            {matchRow.getIn(['firstEntry', 'players']) &&
              <Col
                lg={isMobile ? 12 : 10.55}
                md={isMobile ? 12 : 10.55}
                sm={isMobile ? 12 : 10.55}
                xs={isMobile ? 12 : 10.55}
                style={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                  marginTop: matchRow.getIn(['firstEntry', 'players']).size > 1 ? isMobile ? '3px' : '6px' : '0px',
                  marginBottom: matchRow.getIn(['firstEntry', 'players']).size > 1 ? isMobile ? '6px' : '12px' : '0px',
                }}
              >
                {matchRow && matchRow.get('firstEntry') && matchRow.getIn(['firstEntry', 'players']) &&
                matchRow.getIn(['firstEntry', 'players'])
                  .map((player, index) => (
                    <React.Fragment key={index}>
                      <Label
                        key={index}
                        increment={matchRow.getIn(['firstEntry', 'players']).size > 1 ? playerIncrement += 1 : playerIncrement = 0}
                        label={`${playerNameLabel(player, isMobile)}`}
                        alignSelf="flex-start"
                        margin={isMobile ? '0px 0px 7px 10px' : ''}
                        lineHeight={1.1}
                        weight={isHomeWinner(matchRow.getIn(['firstEntry', 'score']), matchRow.getIn(['secondEntry', 'score']))
                        && matchRow.get('statusDetail') !== status.SUSPENDED_STATUS ? 'bold' : ''}
                        size={matchRow.getIn(['secondEntry', 'players']).size > 1 ? 0.8 : isMobile ? 0.8 : 0.9}
                      />
                      {!isMobile && twoPlayerFounded(matchRow.getIn(['firstEntry', 'players']).size, playerIncrement, isMobile, true)}
                      {resetIncrement()}
                    </React.Fragment>
                  ))
                }
              </Col>
            }
          </Row>
          <Row style={{
            width: '100%', marginRight: '0', marginLeft: '0', marginTop: '0px', alignItems: 'center',
          }}
          >
            {!isMobile && matchRow.getIn(['secondEntry', 'players']) && matchRow.getIn(['secondEntry', 'players']).size < 2 &&
              <Col
                lg={1.45}
                md={1.45}
                sm={1.45}
                xs={1.45}
                style={{
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
              >
                <TeamLabel
                  image={`${countriesUrl}${matchRow.getIn(['secondEntry', 'players', 0, 'nationality'])}.jpg`}
                  isFlag
                />
              </Col>
            }
            {matchRow.getIn(['secondEntry', 'players']) &&
              <Col
                lg={isMobile ? 12 : 10.55}
                md={isMobile ? 12 : 10.55}
                sm={isMobile ? 12 : 10.55}
                xs={isMobile ? 12 : 10.55}
                style={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                  marginBottom: matchRow.getIn(['secondEntry', 'players']).size > 1 ? isMobile ? '0px' : '3px' : '0px',
                }}
              >
                {matchRow && matchRow.get('secondEntry') && matchRow.getIn(['secondEntry', 'players']) &&
                matchRow.getIn(['secondEntry', 'players'])
                  .map((player, index) => (
                    <React.Fragment key={index}>
                      <Label
                        key={index}
                        increment={matchRow.getIn(['secondEntry', 'players']).size > 1 ? playerIncrement += 1 : playerIncrement = 0}
                        label={playerNameLabel(player, isMobile)}
                        alignSelf="flex-start"
                        lineHeight={1.1}
                        weight={isAwayWinner(matchRow.getIn(['firstEntry', 'score']), matchRow.getIn(['secondEntry', 'score']))
                        && matchRow.get('statusDetail') !== status.SUSPENDED_STATUS ? 'bold' : ''}
                        margin={isMobile ? '7px 0px 0px 10px' : ''}
                        size={matchRow.getIn(['secondEntry', 'players']).size > 1 ? 0.8 : isMobile ? 0.8 : 0.9}
                      />
                      {!isMobile && twoPlayerFounded(matchRow.getIn(['secondEntry', 'players']).size, playerIncrement, isMobile)}
                      {resetIncrement()}
                    </React.Fragment>
                  ))
                }
              </Col>
            }
          </Row>
        </Col>
        <Col
          lg={1.3}
          md={1.7}
          sm={1.7}
          xs={1.7}
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: isMobile ? '10px' : '15px',
            paddingRight: '0px',
            overflow: 'initial',
          }}
        >
          <TennisTiming
            matchRow={matchRow}
            isLive={isLive(matchRow)}
            actions={actions}
          />
        </Col>
        {isMobile && matchRow.get('status') === status.NOTSTARTED &&
          <Col
            lg={4}
            md={2.6}
            sm={2.6}
            xs={2.6}
            style={{
              paddingLeft: '0px',
              paddingRight: '0px',
            }}
          />
        }
        {!isMobile &&
          <Col
            lg={0.75}
            md={0.75}
            sm={0.75}
            xs={0.75}
            style={{
              paddingLeft: '0px',
              marginRight: '15px',
              paddingRight: '0px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Label
              label={matchRow.get('status') !== status.NOTSTARTED ? matchRow.getIn(['firstEntry', 'score']) : '-'}
              color={isLive(matchRow) ? 'liveColor' : ''}
              weight={(isLive(matchRow) || (isHomeWinner(matchRow.getIn(['firstEntry', 'score']), matchRow.getIn(['secondEntry', 'score'])) &&
              matchRow.get('statusDetail') !== status.SUSPENDED_STATUS)) ? 'bold' : ''}
              margin="0 0 5px 0"
              alignSelf="flex-end"
              size={1.1}
            />
            <Label
              label={matchRow.get('status') !== status.NOTSTARTED ? matchRow.getIn(['secondEntry', 'score']) : '-'}
              color={isLive(matchRow) ? 'liveColor' : ''}
              weight={(isLive(matchRow) || (isAwayWinner(matchRow.getIn(['firstEntry', 'score']), matchRow.getIn(['secondEntry', 'score'])) &&
              matchRow.get('statusDetail') !== status.SUSPENDED_STATUS)) ? 'bold' : ''}
              margin="5px 0 0 0"
              alignSelf="flex-end"
              size={1.1}
            />
          </Col>
        }
        {!isMobile &&
          <Col
            lg={1.4}
            md={1.4}
            sm={1.4}
            xs={1.4}
            style={{
              paddingLeft: '0px',
              paddingRight: '0px',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'visible',
            }}
          >
            {matchRow.get('status') !== status.NOTSTARTED &&
              <TennisResult
                firstEntry={matchRow.get('firstEntry')}
                secondEntry={matchRow.get('secondEntry')}
                status={matchRow.get('status')}
                isMobile={isMobile}
              />
            }
          </Col>
        }
        {isMobile && matchRow.get('status') !== status.NOTSTARTED &&
          <Col
            lg={4}
            md={2.6}
            sm={2.6}
            xs={2.6}
            style={{
              paddingLeft: isMobile ? '4px' : '15px',
              paddingRight: isMobile ? '0px' : '10px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              overflow: 'visible',
            }}
          >
            <TennisResult
              firstEntry={matchRow.get('firstEntry')}
              secondEntry={matchRow.get('secondEntry')}
              status={matchRow.get('status')}
              isMobile={isMobile}
            />

          </Col>
        }
        <Col
          lg={0.75}
          md={0.92}
          sm={0.92}
          xs={0.92}
          style={{
            display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', paddingRight: isMobile ? '10px' : '0px', paddingLeft: '0px',
          }}
        >
          <IconFont
            className="icon-matchcenter-right-arrow"
            color="selectedColor"
            font={18}
            weight="bold"
            withCursor
          />
        </Col>
      </Row>
    </TennisMatchRowWrapper >
  );
};

TennisMatchRow.propTypes = {
  matchRow: PropTypes.any,
  isMobile: PropTypes.any,
  showRowScorer: PropTypes.any,
  sportId: PropTypes.any,
  actions: PropTypes.any,
  date: PropTypes.any,
};

export default TennisMatchRow;
